import { render, staticRenderFns } from "./GenerateVideoMicrolearningDialog.vue?vue&type=template&id=6b201508&scoped=true"
import script from "./GenerateVideoMicrolearningDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateVideoMicrolearningDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GenerateVideoMicrolearningDialog.vue?vue&type=style&index=0&id=6b201508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b201508",
  null
  
)

export default component.exports